// extracted by mini-css-extract-plugin
export default {"card":"SelectPackage_card__F21ox","carousel":"SelectPackage_carousel__B7H6X"};